import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex max-w-[900px] flex-col items-center px-4 py-24 text-center md:px-6 md:py-32">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-500">
        <i className="ri-emotion-unhappy-line text-3xl"></i>
      </span>
      <p className="mt-6 font-heading text-5xl font-bold text-primary-300 md:text-6xl">404</p>
      <h1 className="mt-3 font-heading text-2xl font-bold text-foreground-950">
        这块瓜田还没开垦
      </h1>
      <p className="mt-3 text-sm text-foreground-600">
        你要找的页面可能已经调整或不存在，回首页继续吃瓜吧。
      </p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i> 返回首页
        </Link>
        <Link
          to="/news"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300"
        >
          <i className="ri-article-line"></i> 看看快讯
        </Link>
      </div>
    </div>
  );
}